<template>
  <div>

    <ul style="overflow:hidden;">
      <li
        style="float:left;margin:5px 5px 5px 5px;margin-right: 10px;position:relative;text-align:left;width:43px;display: inline-block;"
        v-for="procUser in selectMemberModel.selectList" :key="procUser.id">
        <div>
          <div>
            <img style="width:43px;height:43px;" :src="procUser.picture" alt=""></div>
          <div style="text-align:center; font-size: 10px;">
            <span>{{procUser.userName.length>3?procUser.userName.substring(procUser.userName.length-3,procUser.userName.length):procUser.userName}}</span>
          </div>
        </div>
        <i @click="removeUser(procUser,$event)" v-if="deleteIconVisible" class="changeDelete"
           style="position:absolute;top:-3px;left:30px;background:#f00;width:20px;height:20px;font-size:14px;line-height:20px;border-radius:50%;color:#fff">&nbsp;X</i>
      </li>
      <li v-if="addBtnVisible"
          style="float:left;margin:5px 0px 17px 3px;position:relative;text-align:left;width:43px;display: inline-block;">
        <div>
          <svg class="icon" style="font-size:46px;width: 46px;height: 46px;fill:#ccc;" @click="addUser()" aria-hidden="true">
            <use xlink:href="#icon-tianjiarenyuan"></use>
          </svg>
          <!-- <img style="width:45px;height:45px;" @click="addProcUser()" src="../../assets/addPeople1.png"> -->
        </div>
      </li>
      <li v-if="deleteBtnVisible"
          style="float:left;margin:5px 5px 17px 5px;position:relative;text-align:left;width:43px;display: inline-block;">
        <div>
          <svg class="icon" style="font-size:46px;width: 46px;height: 46px;fill:#ccc;" @click="deleteUser()" aria-hidden="true">
            <use xlink:href="#icon-shanchulianxiren"></use>
          </svg>
          <!-- <img style="width:45px;height:45px;" @click="delProcUser()" src="../../assets/removePeople1.png"> -->
        </div>
      </li>
    </ul>
    <selectMember :selectMemberModels='selectMemberModel' ref="selectMemberModel"></selectMember>

  </div>
</template>

<script>
  import {mixin} from './mixin.js'
    export default {
        name: "select-user-cmp",
        mixins: [mixin]
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/common/select-user-cmp/index.vue